module.exports = __webpack_public_path__ + "img/insight.2bf07eed.png";